// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"2318aa80","416":"302b0562","453":"43b98502","538":"16c0f19b","566":"f1dd46fa","882":"fa3cb2ba"}[chunkId] + ".chunk.js";
};